/* DeeVee Fabrics — Theme JavaScript */
(function () {
  'use strict';

  /* ── Helpers ── */
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  /* ── Nav scroll ── */
  const header = $('.site-header');
  on(window, 'scroll', () => {
    header && header.classList.toggle('is-scrolled', window.scrollY > 10);
  }, { passive: true });

  /* ── Mobile nav ── */
  const hamburger = $('.hamburger');
  const mobileNav = $('.mobile-nav');
  const mobileClose = $('.mobile-nav-close');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('open');
    hamburger && hamburger.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('open');
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  on(hamburger, 'click', openMobileNav);
  on(mobileClose, 'click', closeMobileNav);
  $$('.mobile-nav a').forEach(a => on(a, 'click', closeMobileNav));

  /* ── Search modal ── */
  const searchModal = $('.search-modal');
  const searchOpen = $('.search-open');
  const searchClose = $('.search-modal-close');
  const searchInput = $('.search-input');

  function openSearch() {
    searchModal && searchModal.classList.add('open');
    searchModal && searchModal.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch() {
    searchModal && searchModal.classList.remove('open');
    searchModal && searchModal.setAttribute('aria-hidden', 'true');
  }
  on(searchOpen, 'click', openSearch);
  on(searchClose, 'click', closeSearch);
  on(searchModal, 'click', e => { if (e.target === searchModal) closeSearch(); });

  /* ── Cart drawer ── */
  const cartOverlay = $('.cart-overlay');
  const cartDrawer = $('.cart-drawer');
  const cartOpen = $('.cart-open');
  const cartClose = $('.cart-drawer-close');

  function openCart() {
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer && cartDrawer.classList.add('open');
    cartDrawer && cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer && cartDrawer.classList.remove('open');
    cartDrawer && cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on(cartOpen, 'click', openCart);
  on(cartClose, 'click', closeCart);
  on(cartOverlay, 'click', closeCart);

  /* ── Global key handler ── */
  on(document, 'keydown', e => {
    if (e.key === 'Escape') { closeSearch(); closeCart(); closeMobileNav(); }
  });

  /* ── Cart AJAX ── */
  function money(cents) {
    const amount = cents / 100;
    return '₹' + amount.toLocaleString('en-IN', { minimumFractionDigits: Number.isInteger(amount) ? 0 : 2, maximumFractionDigits: 2 });
  }

  async function refreshCart() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      renderCartDrawer(cart);
      updateCartBadge(displayCartCount(cart));
    } catch (e) { console.warn('Cart refresh failed', e); }
  }

  function renderCartDrawer(cart) {
    const itemsEl = $('.cart-items');
    const totalEl = $('.cart-total-price');
    const badgeLine = $('.cart-item-count');
    if (totalEl) totalEl.textContent = money(cart.total_price);
    const visibleCount = displayCartCount(cart);
    if (badgeLine) badgeLine.textContent = visibleCount + ' item' + (visibleCount !== 1 ? 's' : '');

    const drawerWa = document.getElementById('drawer-wa-order');
    const drawerWaLabel = document.getElementById('drawer-wa-label');
    const mixedNote = document.getElementById('drawer-mixed-note');
    const coutureItems = cart.items.filter(item => item.vendor === 'DV Couture' || item.product_type === 'Finished Garment');
    const fabricItems = cart.items.filter(item => item.vendor !== 'DV Couture' && item.product_type !== 'Finished Garment');
    const isMixedCart = coutureItems.length > 0 && fabricItems.length > 0;
    const invalidTenthCart = cart.items.some(item =>
      /-10CM$/i.test(item.sku || '') &&
      (item.quantity < 10 || item.properties?.['Cut Length'] !== (item.quantity / 10).toFixed(2) + ' m continuous cut')
    );
    const drawerCheckout = $('.cart-drawer button[name="checkout"]');
    if (drawerCheckout) {
      drawerCheckout.disabled = invalidTenthCart;
      drawerCheckout.setAttribute('aria-disabled', String(invalidTenthCart));
      let note = $('#drawer-cut-error');
      if (!note) {
        note = document.createElement('p');
        note.id = 'drawer-cut-error';
        note.setAttribute('role', 'alert');
        note.style.cssText = 'font-size:12px;line-height:1.5;color:#9b2929';
        drawerCheckout.closest('form').before(note);
      }
      note.hidden = !invalidTenthCart;
      note.textContent = invalidTenthCart ? 'A fabric cut is below 1.00 m or its length changed. Remove it and choose a new length.' : '';
    }

    if (drawerWa) {
      if (!cart.items.length || isMixedCart || invalidTenthCart) {
        drawerWa.hidden = true;
      } else {
        drawerWa.hidden = false;
        const isCoutureCart = coutureItems.length > 0;
        const number = isCoutureCart ? drawerWa.dataset.coutureNumber : drawerWa.dataset.fabricNumber;
        const lines = cart.items.map((item, index) => {
          const variant = item.variant_title && item.variant_title !== 'Default Title'
            ? ' (' + item.variant_title + ')' : '';
          const tenthUnit = /-10CM$/i.test(item.sku || '');
          const unitPrice = item.final_price ?? item.price;
          const quantity = tenthUnit
            ? (item.quantity / 10).toFixed(2) + ' m continuous cut × ' + money(unitPrice * 10) + '/m'
            : item.quantity + ' × ' + money(unitPrice);
          const lineTotal = item.final_line_price ?? item.line_price ?? item.price * item.quantity;
          return (index + 1) + '. ' + item.product_title + variant + ' — ' + quantity + ' = ' + money(lineTotal);
        });
        const message = 'Hello, I want to complete my ' +
          (isCoutureCart ? 'DV Couture' : 'Dee Vee Fabrics') +
          ' order via WhatsApp:\n' + lines.join('\n') +
          '\n\nCart total: ' + money(cart.total_price) +
          '. Please confirm availability and delivery.';
        drawerWa.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
        if (drawerWaLabel) drawerWaLabel.textContent = isCoutureCart ? 'Order with DV Couture on WhatsApp' : 'Order via WhatsApp';
      }
    }
    if (drawerWa) drawerWa.style.display = drawerWa.hidden ? 'none' : '';
    if (mixedNote) mixedNote.hidden = !isMixedCart;

    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = `
        <div class="cart-empty-state">
          <div class="cart-empty-icon">🧵</div>
          <p class="cart-empty-text">Your cart is empty</p>
          <p class="cart-empty-sub">Explore Dee Vee Fabrics & DV Couture</p>
        </div>`;
      return;
    }
    itemsEl.innerHTML = cart.items.map(item => {
      const isTenthUnit = /-10CM$/i.test(item.sku || '');
      return `
      <div class="cart-item">
        <div class="cart-item-img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div>
          <p class="cart-item-title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          ${isTenthUnit
            ? `<p class="cart-item-variant">${(item.quantity / 10).toFixed(2)} m continuous cut</p>`
            : item.properties && Object.keys(item.properties).length
              ? '<p class="cart-item-variant">Sizing details saved</p>' : ''}
          <p class="cart-item-price">${isTenthUnit
            ? `${(item.quantity / 10).toFixed(2)} m × ${money(item.price * 10)}/m`
            : `${money(item.price)} &times; ${item.quantity}`}</p>
        </div>
        <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">×</button>
      </div>`;
    }).join('');

    const nudge = document.getElementById('drawer-bulk-nudge');
    if (nudge) {
      const fabricMetres = cart.items
        .filter(item => item.vendor !== 'DV Couture' && item.product_type !== 'Finished Garment')
        .reduce((sum, item) => sum + (Number(item.quantity) || 0) / (/-10CM$/i.test(item.sku || '') ? 10 : 1), 0);
      nudge.hidden = fabricMetres < 10;
    }

    $$('.cart-item-remove').forEach(btn => {
      on(btn, 'click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        });
        refreshCart();
      });
    });
  }

  function displayCartCount(cart) {
    return cart.items.reduce((count, item) => count + (/-10CM$/i.test(item.sku || '') ? 1 : item.quantity), 0);
  }

  function updateCartBadge(count) {
    const badge = $('.cart-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ── Add to cart (product page form) ── */
  const atcForm = $('#product-form');
  if (atcForm) {
    const cartError = document.createElement('p');
    cartError.setAttribute('role', 'alert');
    cartError.hidden = true;
    cartError.style.cssText = 'font-size:13px;line-height:1.5;color:#9b2929;margin-top:12px';
    (atcForm.querySelector('.product-ctas') || atcForm).appendChild(cartError);

    on(atcForm, 'submit', async e => {
      e.preventDefault();
      cartError.hidden = true;
      cartError.textContent = '';
      const btn = atcForm.querySelector('.btn-atc');
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      try {
        const fd = new FormData(atcForm);
        const properties = {};
        for (const [key, value] of fd.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']') && String(value).trim() !== '') {
            properties[key.slice(11, -1)] = value;
          }
        }
        const payload = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1) };
        if (Object.keys(properties).length) payload.properties = properties;
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) {
          const failure = new Error(res.status === 422
            ? 'That quantity is not available. Please check your cart and try a smaller amount.'
            : 'We could not add this item. Please try again.');
          failure.customerMessage = true;
          throw failure;
        }
        if (btn) btn.textContent = '✓ Added!';
        const openSizingDialog = document.getElementById('couture-sizing-dialog');
        if (openSizingDialog && openSizingDialog.open) openSizingDialog.close();
        setTimeout(() => { if (btn) { btn.textContent = orig; btn.disabled = false; } openCart(); }, 900);
        refreshCart();
      } catch (err) {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        cartError.textContent = err.customerMessage ? err.message : 'We could not add this item. Please try again.';
        cartError.hidden = false;
        refreshCart();
      }
    });
  }

  /* ── DV Couture sizing dialog ── */
  const sizingDialog = document.getElementById('couture-sizing-dialog');
  const sizingOpen = document.querySelector('[data-sizing-open]');
  const sizingCloseButtons = document.querySelectorAll('[data-sizing-close]');
  on(sizingOpen, 'click', () => {
    if (sizingDialog && typeof sizingDialog.showModal === 'function') sizingDialog.showModal();
  });
  sizingCloseButtons.forEach(btn => on(btn, 'click', () => {
    if (sizingDialog && sizingDialog.open) sizingDialog.close();
  }));
  on(sizingDialog, 'click', e => {
    if (e.target === sizingDialog) sizingDialog.close();
  });

  /* ── Quantity ── */
  window.dvfQty = function (delta) {
    const inp = $('#qty-input');
    if (!inp) return;
    inp.value = Math.min(100, Math.max(1, (parseInt(inp.value) || 1) + delta));
    dvfQtyNudge();
  };
  window.dvfQtyNudge = function () {
    const inp = $('#qty-input'), n = document.getElementById('pdp-bulk-nudge');
    if (!inp || !n) return;
    let v = parseInt(inp.value) || 1;
    if (v < 1) { v = 1; inp.value = 1; }
    if (v > 100) { v = 100; inp.value = 100; }
    n.hidden = v <= 10;
  };
  const qtyInput = $('#qty-input');
  if (qtyInput) { on(qtyInput, 'input', dvfQtyNudge); on(qtyInput, 'change', dvfQtyNudge); }

  /* ── Gallery ── */
  window.dvfThumb = function (thumb) {
    let main = $('#gallery-main-img');
    if (!main) { // a video is showing — put the image back
      const wrap = $('#gallery-main'); if (!wrap) return;
      wrap.innerHTML = '<img id="gallery-main-img" width="1000" height="1333" alt="">'; main = $('#gallery-main-img');
    }
    if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.dataset.src; main.alt = thumb.dataset.alt || ''; }
    $$('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  };

  /* ── Variant selection ── */
  $$('.variant-btn').forEach(btn => {
    on(btn, 'click', () => {
      const group = btn.closest('.variant-options');
      if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const vidEl = $('#variant-id');
      if (vidEl && btn.dataset.variantId) vidEl.value = btn.dataset.variantId;
    });
  });

  /* ── Accordion ── */
  $$('.accordion-btn').forEach(btn => {
    on(btn, 'click', () => {
      const item = btn.closest('.accordion-item');
      if (!item) return;
      const wasOpen = item.classList.contains('open');
      $$('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ── Announcement bar close ── */
  const annClose = $('.ann-bar__close');
  const annBar = $('.ann-bar');
  on(annClose, 'click', () => annBar && (annBar.style.display = 'none'));

  /* ── Reveal on scroll ── */
  if ('IntersectionObserver' in window) {
    const revealIO = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in-view'); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(el => revealIO.observe(el));
  } else {
    $$('.reveal').forEach(el => el.classList.add('in-view'));
  }

  /* ── Sort select ── */
  const sortSel = $('.sort-select');
  on(sortSel, 'change', () => { if (sortSel.value) window.location = sortSel.value; });

  /* ── Init cart count on load ── */
  fetch('/cart.js').then(r => r.json()).then(c => updateCartBadge(displayCartCount(c))).catch(() => {});

})();

/* ── v3: Shop by Video ── */
(function () {
  const tracks = document.querySelectorAll('[data-video-track]');
  if (!tracks.length) return;
  tracks.forEach(track => {
    const section = track.closest('.video-shop');
    const step = () => (track.querySelector('.reel')?.offsetWidth || 240) + 18;
    section?.querySelector('[data-video-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    section?.querySelector('[data-video-next]')?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));

    // Play only the reels on screen (saves data on phones)
    const vids = track.querySelectorAll('video.reel-video');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          const v = e.target;
          if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.4 });
      vids.forEach(v => io.observe(v));
    } else { vids.forEach(v => v.play().catch(() => {})); }

    // Tap for sound — one at a time
    track.querySelectorAll('[data-reel-sound]').forEach(btn => {
      btn.addEventListener('click', () => {
        const v = btn.closest('.reel-media').querySelector('video');
        if (!v) return;
        const turnOn = v.muted;
        track.querySelectorAll('video').forEach(o => { o.muted = true; });
        track.querySelectorAll('[data-reel-sound]').forEach(b => { b.classList.remove('on'); b.setAttribute('aria-label', 'Turn sound on'); });
        if (turnOn) { v.muted = false; btn.classList.add('on'); btn.setAttribute('aria-label', 'Turn sound off'); v.play().catch(() => {}); }
      });
    });
  });
})();

/* ── v3: product gallery video thumbs ── */
window.dvfThumbVideo = function (thumb) {
  const main = document.getElementById('gallery-main');
  if (!main) return;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
  main.innerHTML = '<video controls autoplay muted playsinline loop poster="' + (thumb.dataset.poster || '') + '"><source src="' + thumb.dataset.video + '" type="' + (thumb.dataset.mime || 'video/mp4') + '"></video>';
};
